import { useEffect, useState } from 'react';

export const TICKET_EXAMPLES = [
  "Only Sharon knows the password, and Sharon is in Bali.",
  "The laptop fan sounds like it is preparing for take-off.",
  "The printer and the laptop aren't friends any more.",
  "The shared calendar is neither shared nor a calendar.",
  "The website is down and the person who built it won't reply.",
  "The Wi-Fi drops out every time the microwave runs.",
  "This form asks every customer the same question twice.",
  "We copy customer details between three systems by hand.",
  "We need the boring admin to happen without doing the boring admin.",
  "I retype the same 40 orders every Monday.",
  "Our email signatures have developed independent personalities.",
  "Our stocktake involves a clipboard, two coffees and despair.",
  "The backup says it is backing up. We have trust issues.",
  "The till needs three restarts and a motivational speech.",
  "Customers get the confirmation before we get the booking.",
  "Every invoice is called FINAL-final-actually-final.pdf.",
  "The EFTPOS machine drops out whenever the cordless phone rings.",
  "The label printer only works when the roll is in backwards.",
  "Our online menu is updated everywhere except Google.",
  "The website update is live for us and last Tuesday for everyone else.",
  "The website works on every phone except the owner's.",
  "The QR code works on every table except the one under the window.",
  "The computer clock is five minutes wrong and now nothing will log in.",
  "Everyone can open the shared file. Nobody can save it.",
  "Our two-factor code arrives just after it expires.",
  "The calendar moved every appointment by an hour and blamed daylight saving.",
  "The mouse stops working on the shiny new desk.",
  "The old computer can open the file. The new one can only admire it.",
];

export function useTypingPlaceholder(active = true, targetRef = null, examples = TICKET_EXAMPLES) {
  const [text, setText] = useState(examples[0]);
  const [isOnScreen, setIsOnScreen] = useState(true);

  useEffect(() => {
    const target = targetRef?.current;
    if (!target || !('IntersectionObserver' in window)) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => setIsOnScreen(entry.isIntersecting),
      { rootMargin: '120px 0px' },
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, [targetRef]);

  useEffect(() => {
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (!active || !isOnScreen || reducedMotion) {
      setText(examples[0]);
      return undefined;
    }

    let exampleIndex = 0;
    let position = 0;
    let direction = 1;
    let timer;

    const tick = () => {
      const current = examples[exampleIndex];

      if (direction === 1) {
        position += 1;
        setText(`${current.slice(0, position)}${position < current.length ? '▌' : ''}`);

        if (position >= current.length) {
          direction = -1;
          timer = window.setTimeout(tick, 2600);
        } else {
          timer = window.setTimeout(tick, 34);
        }
        return;
      }

      position -= 2;
      if (position <= 0) {
        position = 0;
        exampleIndex = (exampleIndex + 1) % examples.length;
        direction = 1;
        setText('▌');
        timer = window.setTimeout(tick, 300);
      } else {
        setText(`${current.slice(0, position)}▌`);
        timer = window.setTimeout(tick, 14);
      }
    };

    timer = window.setTimeout(tick, 400);
    return () => window.clearTimeout(timer);
  }, [active, examples, isOnScreen]);

  return text;
}
